<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para1"><a id="page_4"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the authors’ imaginations or are used fictitiously.</p>
<p class="para1">SECRET OF THE DRAGON</p>
<p class="para1">Copyright © 2010 by Margaret Weis and Tracy Hickman</p>
<p class="para1">All rights reserved.</p>
<p class="para1">A Tor Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="para1"><a href="http://www.tor-forge.com" target="_blank">www.tor-forge.com</a></p>
<p class="para1">Tor<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="para1">ISBN 978-0-7653-1974-6 (hardcover)<br/>ISBN 978-0-7653-2692-8 (first international trade paperback edition)</p>
<p class="para1">First Edition: March 2010</p>
<p class="para1">Printed in the United States of America</p>
<p class="para1">0  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?481a495c